<template>
  <div>
    <AddPackage update @update="updatePackage = !updatePackage" :key="updatePackage" @numberOfAddedCourse="checkNumberOfAddedCourse" />
    <Toast title="بروزرسانی با موفقیت انجام شد" :showToast="showToast" />
  </div>
</template>
<script>
import appConfig from '@/app.config'
import AddPackage from '../../../components/skillup/packages/AddPackage.vue'
import Toast from '../../../components/common/Toast.vue'
export default {
  page: {
    title: 'ویرایش دوره جامع',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-edit-packages',
  data() {
    return {
      updatePackage: false,
      showToast: false,
    }
  },
  watch: {
    updatePackage() {
      this.updateToast()
    },
  },
  methods: {
    updateToast() {
      this.showToast = true
    },
    checkNumberOfAddedCourse(course) {
      this.$route.query.courseLength = course
    },
  },
  components: {
    AddPackage,
    Toast,
  },
}
</script>
